export default __webpack_public_path__ + "static/media/applications.a3537a24.svg";